<template>
  <ModalContainer :show="show" @close="onCancel">
    <!-- <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading> -->
    <template slot="header">
      <h4 class="mb-0">{{ $t("logistics") }}</h4>
    </template>

    <template slot="body">
      <form class="p-2" @submit.prevent="handleNext">
        <div class="form-group">
          <label>Shipment type</label>
          <select v-model="type" class="form-control">
            <option value="" disabled selected>Select</option>
            <option
              v-for="shipmentType in shipmentTypes"
              :key="shipmentType.value"
              :value="shipmentType.value"
            >
              {{ shipmentType.label }}
            </option>
          </select>
        </div>
        <div class="btn-add">
          <button
            :disabled="!type"
            :class="{
              'invalid-button': !type,
              'valid-button': type,
            }"
            type="submit"
          >
            {{ $t("next") }}
          </button>
        </div>
      </form>
    </template>
  </ModalContainer>
</template>

<script>
import ModalContainer from "../../components/ModalContainer";
import { mapActions } from "vuex";
export default {
  name: "Add Shipment",
  components: {
    ModalContainer,
  },
  props: {
    show: Boolean,
    onCancel: Function,
  },

  data() {
    return {
      type: "",
      shipmentTypes: [
        {
          label: "Sea Freight",
          value: "sea",
        },
        {
          label: "Air Freight",
          value: "air",
        },
      ],
    };
  },

  methods: {
    ...mapActions(["updateShipmentType"]),
    handleNext() {
      this.updateShipmentType(this.type);
      this.$router.push("/export/dispatch/add-shipment");
    },
  },
};
</script>

<style scoped>
select {
  width: 100%;
  height: 50px;
  margin-bottom: 24px;
}
label,
.form-control::placeholder {
  font-weight: 400;
  color: rgba(94, 106, 121, 1);
}

label {
  list-style: 15.6px;
  font-size: 12px;
}
.btn-add {
  padding: 0;
  border-radius: 0;
  width: 100%;
  display: flex;
  justify-content: right;
}

.btn-add > button {
  border: none;
  border-radius: 16px;
  color: rgba(247, 248, 249, 1);
  width: 84px;
  height: 44px;
  padding: 12px, 30px, 12px, 30px;
  font-size: 14px;
  font-weight: 600;
}

.valid-button {
  background-color: rgba(33, 62, 122, 1);
  cursor: pointer;
}

.invalid-button {
  background-color: rgba(33, 62, 122, 0.8);
}
</style>
